// extracted by mini-css-extract-plugin
module.exports = {"bgWrapper":"AllItemsPage_bgWrapper__1dmQK","empty-results":"AllItemsPage_empty-results__Pe1t2"};